import { RTE_PARAGRAPH_GAP } from './richTextParagraphs';

import { LEARNER_UI_PERSIAN_STACK } from '../constants/learnerPersianFonts';



/** Admin editor + preview: always Vazirmatn — pasted font faces are ignored. */

export const LESSON_RICH_TEXT_ADMIN_FONT_STACK = LEARNER_UI_PERSIAN_STACK;



/**

 * Shared CSS for lesson rich text in the admin editor and learner FormattedTextBlock.

 * `scope` is a selector prefix, e.g. `.rich-text-editor-body` or `#formatted-text-abc`.

 */

export const getLessonRichTextBlockCss = (

  scope: string,

  fontStack: string = LESSON_RICH_TEXT_ADMIN_FONT_STACK

): string => `

  ${scope} {

    line-height: 1.6;

    font-family: ${fontStack};

  }

  ${scope} > div {

    display: block;

    margin-bottom: ${RTE_PARAGRAPH_GAP};

    line-height: inherit;

  }

  ${scope} > div:not([data-align]) {

    text-align: left;

    direction: ltr;

  }

  ${scope} > div:last-child {

    margin-bottom: 0;

  }

  /* Nested Word wrappers — no extra paragraph gap */

  ${scope} > div > div:only-child {

    margin-bottom: 0;

  }

  ${scope} div[data-direction="rtl"] {

    direction: rtl;

  }

  ${scope} div[data-align="left"] {

    text-align: left;

    text-align-last: auto;

    direction: ltr;

  }

  ${scope} div[data-align="left"][data-direction="rtl"] {

    text-align: left;

    text-align-last: auto;

    direction: rtl;

  }

  ${scope} div[data-align="right"] {

    text-align: right;

    text-align-last: auto;

    direction: ltr;

  }

  ${scope} div[data-align="right"][data-direction="rtl"] {

    text-align: right;

    text-align-last: auto;

    direction: rtl;

  }

  ${scope} div[data-align="justify"] {

    text-align: justify;

    text-align-last: auto;

    direction: ltr;

  }

  ${scope} div[data-align="justify-right"] {

    text-align: justify;

    text-align-last: right;

    direction: rtl;

  }

  ${scope} b,

  ${scope} strong {

    font-weight: bold;

  }

  ${scope} u {

    text-decoration: underline;

  }

  ${scope} i,

  ${scope} em {

    font-style: italic;

  }

  ${scope} font[face],

  ${scope} span[style*="font-family"] {

    display: inline;

    font-family: inherit !important;

  }

  ${scope} a {

    color: inherit;

    text-decoration: underline;

    text-underline-offset: 2px;

  }

  ${scope} ul,

  ${scope} ol {

    list-style-position: outside;

    margin: ${RTE_PARAGRAPH_GAP} 0;

    padding-inline-start: 2.25em;

  }

  ${scope} ul[dir="rtl"],

  ${scope} ol[dir="rtl"] {

    direction: rtl;

  }

  ${scope} ul[dir="ltr"],

  ${scope} ol[dir="ltr"] {

    direction: ltr;

  }

  ${scope} ul {

    list-style-type: disc;

  }

  ${scope} ol {

    list-style-type: decimal;

  }

  ${scope} ul ul,

  ${scope} ol ul {

    list-style-type: circle;

  }

  ${scope} ul ul ul,

  ${scope} ol ul ul {

    list-style-type: square;

  }

  ${scope} ul:first-child,

  ${scope} ol:first-child {

    margin-top: 0;

  }

  ${scope} ul:last-child,

  ${scope} ol:last-child {

    margin-bottom: 0;

  }

  ${scope} li {

    display: list-item;

    margin-bottom: 0.15em;

    padding-inline-start: 0;

    margin-inline-start: 0;

    text-indent: 0;

  }

  ${scope} li[data-align="left"] {

    text-align: left;

    direction: ltr;

  }

  ${scope} li[data-align="left"][data-direction="rtl"] {

    text-align: left;

    direction: rtl;

  }

  ${scope} li[data-align="right"] {

    text-align: right;

    direction: ltr;

  }

  ${scope} li[data-align="right"][data-direction="rtl"] {

    text-align: right;

    direction: rtl;

  }

  ${scope} li[data-align="justify"] {

    text-align: justify;

    direction: ltr;

  }

  ${scope} li[data-align="justify-right"] {

    text-align: justify;

    text-align-last: right;

    direction: rtl;

  }

  ${scope} table {

    border-collapse: collapse;

    width: 100%;

    max-width: 100%;

    margin: ${RTE_PARAGRAPH_GAP} 0;

    font-size: inherit;

  }

  ${scope} table[dir="rtl"] {

    direction: rtl;

  }

  ${scope} table:first-child {

    margin-top: 0;

  }

  ${scope} table:last-child {

    margin-bottom: 0;

  }

  ${scope} th,

  ${scope} td {

    border: 1px solid rgba(120, 120, 120, 0.35);

    padding: 0.25em 0.5em;

    vertical-align: top;

  }

  ${scope} th {

    font-weight: 600;

  }

`;



/** Learner view: shared block rules plus lesson font stack and stronger format overrides. */

export const getLessonRichTextLearnerCss = (scope: string, lessonStack: string): string => `

  ${scope} {

    font-family: ${lessonStack};

    white-space: normal;

  }

  ${getLessonRichTextBlockCss(scope, lessonStack)}

  ${scope} b,

  ${scope} strong {

    font-weight: bold !important;

  }

  ${scope} u {

    text-decoration: underline !important;

  }

  ${scope} i,

  ${scope} em {

    font-style: italic !important;

  }

`;


